import { LayoutList } from "lucide-react";
import CommonEmptyState from "../../common/empty-state";

export default function ListingEmptyState({
  callToAction,
}: {
  callToAction?: React.ReactNode;
}) {
  return (
    <CommonEmptyState
      icon={<LayoutList />}
      title="No active listings yet"
      descrption=" This property has no active lisitngs yet."
      callToAction={callToAction}
    />
  );
}
